import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

const Tab = (props) => {
    const {
        className,
        id,
        disabled,
        text,
        selected,
        linkProps,
        rowIconRender = () => {},
        namedLinkClassName,
    } = props;
    const linkClasses = classNames(
        css.link,
        {
            [css.selectedLink]: selected,
            [css.disabled]: disabled,
        },
        namedLinkClassName || ''
    );

    //-----------  Edit Listing Page > Tab > navigation icon  ----------//
    const desNav = 'EditListingWizard_description';
    const feaNav = 'EditListingWizard_features';
    const clusNav = 'EditListingWizard_cluster';
    const priNav = 'EditListingWizard_pricing';
    const aviNav = 'EditListingWizard_availability';
    const phoNav = 'EditListingWizard_photos';

    let icon = null;

    if (id === desNav) {
        icon = (
            <svg
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="35"
                    cy="35"
                    r="34"
                    stroke="#B2B2B2"
                    stroke-width="2"
                />
                <path
                    d="M37.9061 29.5875L30.7498 30.4844L30.4936 31.6719L31.8999 31.9313C32.8186 32.15 32.9999 32.4813 32.7999 33.3969L30.4936 44.2344C29.8874 47.0375 30.8217 48.3563 33.0186 48.3563C34.7217 48.3563 36.6999 47.5688 37.5967 46.4875L37.8717 45.1875C37.2467 45.7375 36.3342 45.9563 35.728 45.9563C34.8686 45.9563 34.5561 45.3531 34.778 44.2906L37.9061 29.5875ZM38.1249 23.0625C38.1249 23.8913 37.7956 24.6862 37.2096 25.2722C36.6235 25.8583 35.8287 26.1875 34.9999 26.1875C34.171 26.1875 33.3762 25.8583 32.7901 25.2722C32.2041 24.6862 31.8749 23.8913 31.8749 23.0625C31.8749 22.2337 32.2041 21.4388 32.7901 20.8528C33.3762 20.2667 34.171 19.9375 34.9999 19.9375C35.8287 19.9375 36.6235 20.2667 37.2096 20.8528C37.7956 21.4388 38.1249 22.2337 38.1249 23.0625Z"
                    fill="#B2B2B2"
                />
            </svg>
        );
    } else if (id === feaNav) {
        icon = (
            <svg
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="35"
                    cy="35"
                    r="34"
                    stroke="#B2B2B2"
                    stroke-width="2"
                />
                <path
                    d="M28.4375 46.7188C28.4375 46.9969 28.355 47.2688 28.2005 47.5C28.046 47.7313 27.8264 47.9115 27.5694 48.018C27.3124 48.1244 27.0297 48.1522 26.7569 48.098C26.4841 48.0437 26.2335 47.9098 26.0369 47.7131C25.8402 47.5165 25.7063 47.2659 25.652 46.9931C25.5978 46.7203 25.6256 46.4376 25.732 46.1806C25.8385 45.9236 26.0187 45.704 26.25 45.5495C26.4812 45.395 26.7531 45.3125 27.0313 45.3125C27.4042 45.3125 27.7619 45.4607 28.0256 45.7244C28.2893 45.9881 28.4375 46.3458 28.4375 46.7188ZM30.3125 42.0313C30.0344 42.0313 29.7625 42.1137 29.5312 42.2682C29.3 42.4228 29.1197 42.6424 29.0133 42.8994C28.9069 43.1563 28.879 43.4391 28.9333 43.7118C28.9875 43.9846 29.1215 44.2352 29.3181 44.4319C29.5148 44.6285 29.7654 44.7625 30.0382 44.8167C30.3109 44.871 30.5937 44.8431 30.8506 44.7367C31.1076 44.6303 31.3272 44.45 31.4818 44.2188C31.6363 43.9875 31.7188 43.7156 31.7188 43.4375C31.7188 43.0645 31.5706 42.7069 31.3069 42.4431C31.0431 42.1794 30.6855 42.0313 30.3125 42.0313ZM23.2813 41.5625C23.0031 41.5625 22.7312 41.645 22.5 41.7995C22.2687 41.954 22.0885 42.1736 21.982 42.4306C21.8756 42.6876 21.8478 42.9703 21.902 43.2431C21.9563 43.5159 22.0902 43.7665 22.2869 43.9631C22.4835 44.1598 22.7341 44.2937 23.0069 44.348C23.2797 44.4022 23.5624 44.3744 23.8194 44.268C24.0764 44.1615 24.296 43.9813 24.4505 43.75C24.605 43.5188 24.6875 43.2469 24.6875 42.9688C24.6875 42.5958 24.5393 42.2381 24.2756 41.9744C24.0119 41.7107 23.6542 41.5625 23.2813 41.5625ZM27.9688 39.6875C27.9688 39.4094 27.8863 39.1375 27.7318 38.9062C27.5772 38.675 27.3576 38.4947 27.1006 38.3883C26.8437 38.2819 26.5609 38.254 26.2882 38.3083C26.0154 38.3625 25.7648 38.4965 25.5681 38.6931C25.3715 38.8898 25.2375 39.1404 25.1833 39.4132C25.129 39.6859 25.1569 39.9687 25.2633 40.2256C25.3697 40.4826 25.55 40.7022 25.7812 40.8568C26.0125 41.0113 26.2844 41.0938 26.5625 41.0938C26.9355 41.0938 27.2931 40.9456 27.5569 40.6819C27.8206 40.4181 27.9688 40.0605 27.9688 39.6875ZM50 24.6875C50 24.9361 49.9012 25.1746 49.7254 25.3504C49.5496 25.5262 49.3111 25.625 49.0625 25.625H45.6992L42.4414 28.8828L39.9688 43.6719C39.9158 44.0131 39.768 44.3325 39.5421 44.5936C39.3162 44.8547 39.0214 45.047 38.6914 45.1484C38.506 45.209 38.3123 45.2406 38.1172 45.2422C37.6243 45.2382 37.1528 45.0404 36.8047 44.6914L25.3086 33.1953C25.0675 32.9525 24.8975 32.6483 24.8169 32.3157C24.7363 31.9831 24.7483 31.6348 24.8516 31.3086C24.953 30.9786 25.1453 30.6838 25.4064 30.4579C25.6675 30.232 25.9869 30.0842 26.3281 30.0313L41.1172 27.5586L44.375 24.3008C44.5484 24.1261 44.7547 23.9874 44.982 23.8929C45.2093 23.7983 45.4531 23.7498 45.6992 23.75H49.0625C49.3111 23.75 49.5496 23.8488 49.7254 24.0246C49.9012 24.2004 50 24.4389 50 24.6875ZM40.4258 29.5742L26.6328 31.8711L38.1289 43.3672L40.4258 29.5742Z"
                    fill="#B2B2B2"
                />
            </svg>
        );
    } else if (id === clusNav) {
        icon = (
            <svg
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="35"
                    cy="35"
                    r="34"
                    stroke="#B2B2B2"
                    stroke-width="2"
                />
                {/* <path
                    d="M45.7812 44.8435V25.156H40.625V20.7617L25.1562 23.4287V44.8435H20.9375V46.7185H26.0293L40.625 48.7316V27.031H43.9062V46.7185H49.0625V44.8435H45.7812ZM38.75 46.5803L27.0312 44.9639V25.0082L38.75 22.988V46.5803Z"
                    fill="#B2B2B2"
                />
                <path
                    d="M35 33.5938H36.875V37.3438H35V33.5938Z"
                    fill="#B2B2B2"
                /> */}
                <path fill-rule="evenodd" clip-rule="evenodd" d="M32.5929 21H30.9139V48.7035H32.5929V21ZM30.3809 21H24.3809C24.165 20.999 23.9547 21.0678 23.7812 21.1963C23.6077 21.3247 23.4804 21.5058 23.4184 21.7125L20.1684 32.75C19.8912 33.667 19.9579 34.6536 20.3559 35.525C21.1584 37.2978 22.4163 38.8263 24.0016 39.9549C25.5869 41.0836 27.443 41.7719 29.3809 41.95V46.9999H25.3809C25.1157 46.9999 24.8613 47.1053 24.6738 47.2928C24.4862 47.4804 24.3809 47.7347 24.3809 47.9999C24.3809 48.2652 24.4862 48.5195 24.6738 48.707C24.8613 48.8946 25.1157 48.9999 25.3809 48.9999H30.3809L30.3809 40.003C28.6501 40.003 26.956 39.5039 25.5016 38.5656C24.0472 37.6272 22.8943 36.2894 22.1809 34.7125C21.9795 34.2732 21.944 33.7759 22.0809 33.3125L22.4059 32.2375C23.7809 31.625 26.3309 31.1 29.9309 32.9C30.0823 32.9752 30.2323 33.047 30.3809 33.1154V30.8849C27.3149 29.4759 24.8459 29.4952 23.0934 29.9125L25.1309 23H30.3809V21ZM33.432 48.7046H48.0762C48.601 48.7046 49.1044 48.4962 49.4755 48.1251C49.8466 47.754 50.055 47.2506 50.055 46.7258V38.7017C49.4869 39.2871 48.8162 39.7633 48.0762 40.1066V46.7258H33.432V48.7046ZM33.432 38.8098H40.1607V40.1949C40.1607 40.4573 40.2649 40.709 40.4505 40.8946C40.636 41.0801 40.8877 41.1844 41.1501 41.1844C41.4125 41.1844 41.6641 41.0801 41.8497 40.8946C42.0352 40.709 42.1395 40.4573 42.1395 40.1949V34.7927H40.1607V36.8309H33.432V38.8098ZM33.432 26.9367H48.0762V33.8626C48.0762 34.6498 47.7635 35.4048 47.2068 35.9614C46.6502 36.5181 45.8952 36.8308 45.108 36.8308H44.1186V38.8096H45.108C46.42 38.8096 47.6783 38.2884 48.6061 37.3607C49.5338 36.4329 50.055 35.1746 50.055 33.8626V25.9473C50.055 25.6848 49.9508 25.4332 49.7652 25.2476C49.5797 25.0621 49.328 24.9578 49.0656 24.9578H40.1609V23.355C40.1505 22.7217 39.8895 22.1183 39.4352 21.6769C38.9809 21.2356 38.3702 20.9923 37.7368 21.0002H33.432V22.979H37.7467C37.8026 22.9777 37.8582 22.9874 37.9103 23.0076C37.9624 23.0278 38.0101 23.058 38.0505 23.0966C38.0909 23.1352 38.1234 23.1814 38.1459 23.2325C38.1685 23.2836 38.1808 23.3387 38.1821 23.3946V24.9578H33.432V26.9367Z" fill="#B2B2B2"/>

            </svg>
        );
    } else if (id === priNav) {
        icon = (
            <svg
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="35"
                    cy="35"
                    r="34"
                    stroke="#B2B2B2"
                    stroke-width="2"
                />
                <path
                    d="M45.3125 27.5H42.3125C42.5 26.75 42.5 26 42.5 25.25C42.3125 24.6875 42.125 24.125 41.75 23.5625C41.375 23 41 22.625 40.4375 22.4375C39.875 22.25 39.3125 21.875 38.75 21.875C38.1875 21.875 37.625 21.875 37.0625 22.25C35.75 22.625 34.8125 23.5625 34.0625 24.6875C33.3125 23.5625 32.375 22.625 31.0625 22.25C30.5 22.0625 29.9375 21.875 29.375 21.875C28.8125 21.875 28.25 22.0625 27.6875 22.4375C27.125 22.625 26.75 23 26.375 23.5625C26 23.9375 25.8125 24.6875 25.625 25.25C25.625 26 25.625 26.75 25.8125 27.5H22.8125L21.875 28.4375V45.3125L22.8125 46.25H45.3125L46.25 45.3125V28.4375L45.3125 27.5ZM33.125 44.375H23.75V29.375H33.125V44.375ZM33.125 27.5H27.5V27.125C27.3125 26.5625 27.3125 26.1875 27.3125 25.625C27.5 25.25 27.5 24.875 27.875 24.6875C28.0625 24.3125 28.4375 24.125 28.8125 23.9375C29 23.75 29.375 23.75 29.75 23.75C30.125 23.75 30.5 23.75 30.875 23.9375C31.4375 24.125 32 24.5 32.375 25.0625C32.75 25.625 33.125 26.1875 33.125 26.9375V27.5ZM35 26.9375C35 26.1875 35.375 25.625 35.75 25.0625C36.125 24.5 36.6875 24.125 37.25 23.9375C37.625 23.75 38 23.75 38.375 23.75C38.75 23.75 39.125 23.75 39.5 23.9375C39.875 24.125 40.0625 24.3125 40.4375 24.6875C40.625 24.875 40.625 25.25 40.8125 25.625C40.8125 26.1875 40.8125 26.5625 40.625 27.125C40.625 27.3125 40.625 27.3125 40.4375 27.5H35V26.9375ZM44.375 44.375H35V29.375H44.375V44.375Z"
                    fill="#B2B2B2"
                />
            </svg>
        );
    } else if (id === aviNav) {
        icon = (
            <svg
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="35"
                    cy="35"
                    r="34"
                    stroke="#B2B2B2"
                    stroke-width="2"
                />
                <path
                    d="M45.7812 25.3906H40.8594V23.5156C40.8594 23.3867 40.7539 23.2812 40.625 23.2812H38.9844C38.8555 23.2812 38.75 23.3867 38.75 23.5156V25.3906H31.25V23.5156C31.25 23.3867 31.1445 23.2812 31.0156 23.2812H29.375C29.2461 23.2812 29.1406 23.3867 29.1406 23.5156V25.3906H24.2188C23.7002 25.3906 23.2812 25.8096 23.2812 26.3281V45.7812C23.2812 46.2998 23.7002 46.7188 24.2188 46.7188H45.7812C46.2998 46.7188 46.7188 46.2998 46.7188 45.7812V26.3281C46.7188 25.8096 46.2998 25.3906 45.7812 25.3906ZM44.6094 44.6094H25.3906V33.4766H44.6094V44.6094ZM25.3906 31.4844V27.5H29.1406V28.9062C29.1406 29.0352 29.2461 29.1406 29.375 29.1406H31.0156C31.1445 29.1406 31.25 29.0352 31.25 28.9062V27.5H38.75V28.9062C38.75 29.0352 38.8555 29.1406 38.9844 29.1406H40.625C40.7539 29.1406 40.8594 29.0352 40.8594 28.9062V27.5H44.6094V31.4844H25.3906Z"
                    fill="#B2B2B2"
                />
            </svg>
        );
    } else if (id === phoNav) {
        icon = (
            <svg
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35 68C53.2254 68 68 53.2254 68 35C68 16.7746 53.2254 2 35 2C16.7746 2 2 16.7746 2 35C2 53.2254 16.7746 68 35 68ZM35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70ZM30.4375 25.625C29.402 25.625 28.5625 26.4645 28.5625 27.5C28.5625 28.5355 29.402 29.375 30.4375 29.375C31.473 29.375 32.3125 28.5355 32.3125 27.5C32.3125 26.4645 31.473 25.625 30.4375 25.625ZM26.6875 27.5C26.6875 25.4289 28.3664 23.75 30.4375 23.75C32.5086 23.75 34.1875 25.4289 34.1875 27.5C34.1875 29.5711 32.5086 31.25 30.4375 31.25C28.3664 31.25 26.6875 29.5711 26.6875 27.5ZM22.9375 20C22.4197 20 22 20.4197 22 20.9375V47.1875C22 47.7053 22.4197 48.125 22.9375 48.125H49.1875C49.7053 48.125 50.125 47.7053 50.125 47.1875V20.9375C50.125 20.4197 49.7053 20 49.1875 20H22.9375ZM23.875 46.25V43.8258L32.3125 35.3883L39.1496 42.2254C39.3254 42.4012 39.5639 42.5 39.8125 42.5H48.25V46.25H23.875ZM40.2008 40.625L37.3883 37.8125L41.6875 33.5133L48.25 40.0758V40.625H40.2008ZM42.3504 31.5246L48.25 37.4242V21.875H23.875V41.1742L31.6496 33.3996C32.0157 33.0335 32.6093 33.0335 32.9754 33.3996L36.0625 36.4867L41.0246 31.5246C41.3907 31.1585 41.9843 31.1585 42.3504 31.5246Z"
                    fill="#4A4A4A"
                />
            </svg>
        );
    } else {
        icon = '';
    }

    return (
        <div id={id} className={className}>
            <NamedLink className={linkClasses} {...linkProps}>
                {icon}
                <div style={{ marginTop: '10px' }}>
                    {rowIconRender(selected)}
                    {text}
                </div>
            </NamedLink>
        </div>
    );
};

Tab.defaultProps = { className: null, disabled: false, selected: false };

const { arrayOf, bool, node, object, string } = PropTypes;

Tab.propTypes = {
    id: string.isRequired,
    className: string,
    text: node.isRequired,
    disabled: bool,
    selected: bool,
    linkProps: object.isRequired,
};

const TabNav = (props) => {
    const {
        className,
        rootClassName,
        tabRootClassName,
        tabs,
        namedLinkClassName,
    } = props;
    const classes = classNames(rootClassName || css.root, className);
    const tabClasses = tabRootClassName || css.tab;
    return (
        <nav className={classes}>
            {tabs.map((tab, index) => {
                const id = typeof tab.id === 'string' ? tab.id : `${index}`;
                return (
                    <Tab
                        key={id}
                        id={id}
                        className={tabClasses}
                        namedLinkClassName={namedLinkClassName}
                        {...tab}
                    />
                );
            })}
        </nav>
    );
};

TabNav.defaultProps = {
    className: null,
    rootClassName: null,
    tabRootClassName: null,
    tabClassName: null,
};

TabNav.propTypes = {
    className: string,
    rootClassName: string,
    tabRootClassName: string,
    tabs: arrayOf(object).isRequired,
};

export default TabNav;
